export const URLS = {
  facebook: 'https://www.facebook.com/FIGHTBACKWRESTLING/',
  instagram: 'https://www.instagram.com/fightback_wrestling/',
  youtube: 'https://www.youtube.com/@FIGHTBACKWRESTLING',
  whatsapp: 'https://www.whatsapp.com/channel/0029VaMhIz6Jf05iheIQTS0U',
  linktree: 'https://linktr.ee/fightbackwrestling',
  slWrestling: 'https://sl-wrestling.de/produkt-kategorie/ligen/fightback-wrestling/',
  oktv: 'https://www.ok-mainz.de/sendung/fightback-wrestling/',
  vakantWrestlerImage: 'https://cms.fightback-wrestling.com/wp-content/uploads/2024/03/Vakant.png',
  factoryImage: 'https://cms.fightback-wrestling.com/wp-content/uploads/2025/03/ghw.jpeg',
  sgsImage: 'https://cms.fightback-wrestling.com/wp-content/uploads/2025/03/ngw.jpeg',
  startScreenPlaceholderBackground:
    'https://cms.fightback-wrestling.com/wp-content/uploads/2025/03/Fightback-WRESTLING-Banner_OhneGlas-scaled.jpg',
  startScreenPlaceholderBackgroundGlass:
    'https://cms.fightback-wrestling.com/wp-content/uploads/2025/03/Fightback-WRESTLING-Banner-scaled.jpg',
  fightbackPlaceholderLogo:
    'https://cms.fightback-wrestling.com/wp-content/uploads/2025/03/Logo_breit.png',
  fanImage: 'https://cms.fightback-wrestling.com/wp-content/uploads/2025/03/fans-fightback-1.jpg',
  supporterLogo:
    'https://cms.fightback-wrestling.com/wp-content/uploads/2025/03/Supporter-Logo.png',
  supporterPremiumLogo:
    'https://cms.fightback-wrestling.com/wp-content/uploads/2025/03/Premium-Supporter-Logo.png',
  aboutUsBackgrounds: [
    'https://cms.fightback-wrestling.com/wp-content/uploads/2025/10/1.jpeg',
    'https://cms.fightback-wrestling.com/wp-content/uploads/2025/10/3.jpeg',
    'https://cms.fightback-wrestling.com/wp-content/uploads/2025/10/5.jpeg',
    'https://cms.fightback-wrestling.com/wp-content/uploads/2025/10/2.jpeg',
    'https://cms.fightback-wrestling.com/wp-content/uploads/2025/10/4.jpeg',
    'https://cms.fightback-wrestling.com/wp-content/uploads/2025/10/6.jpeg',
  ],
}
